import React, { useState, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";

// 국기 이미지
import img_flag_kr from "../assets/img_flag_kr.svg";
import img_flag_en from "../assets/img_flag_en.svg";
import img_flag_cn from "../assets/img_flag_cn.svg";
import img_flag_vi from "../assets/img_flag_vi.png";
import img_flag_th from "../assets/img_flag_th.png";

const languageImage = {
    ko: img_flag_kr,
    en: img_flag_en,
    cn: img_flag_cn,
    vi: img_flag_vi,
    th: img_flag_th
};

const languageText = {
    ko: "KOREA",
    en: "ENGLISH",
    cn: "CHINESE",
    vi: "VIETNAM",
    th: "THAILAND"
};

const Header = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [headerClass, setHeaderClass] = useState("sub");

    const [data, setData] = useState();
    const [searchParams] = useSearchParams();

    const [langShow, setLangShow] = useState("");

    useEffect(() => {
        let token = searchParams.get("token");
        if (!!token) {
            localStorage.setItem("fb_token", token);
        } else {
            token = localStorage.getItem("fb_token");
        }

        if (!!token && data) {
            data.fb_token = token;
            Update(
                data,
                res => {
                    localStorage.setItem("fb_token", "");
                },
                res => {}
            );
        }
    }, [searchParams, data]);

    useEffect(() => {
        if (location.pathname === "/") {
            setHeaderClass("main");
        } else {
            setHeaderClass("sub");
        }
    }, [location]);

    useEffect(() => {
        AuthMe(
            res => {
                setData(res);
            },
            res => {
                setData();
            }
        );

        return () => {};
    }, []);

    const clickLogout = () => {
        setData();
        localStorage.setItem("access_token", "");
        localStorage.setItem("refresh_token", "");
        localStorage.setItem("token_type", "");
        localStorage.setItem("expires_in", "");
        window.location = "/";
    };

    const findNextKey = currentKey => {
        const keys = Object.keys(languageImage);
        const currentIndex = keys.indexOf(currentKey);

        if (currentIndex !== -1) {
            const nextIndex = (currentIndex + 1) % keys.length;
            return keys[nextIndex];
        }

        return keys[0];
    };

    function langMenuToggle() {
        setLangShow(!langShow);
    }

    const clickReload= () => {
        window.location.replace('/');
    };

    return (
        <header className={`header-wrapper ${headerClass}`}>
            {/* pc 메뉴 */}
            <div className="inner">
                <h1 className="logo">
                    <button onClick={() => clickReload()}>{t("효심")}</button>
                </h1>
            </div>

            <Link className="Home_ico" onClick={() => clickReload()}></Link>
        </header>
    );
};

export default Header;
